import {
  ComplianceDocument_Read,
  ComplianceDocument_Read_Nested,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { ComplianceDocumentTypeBasic } from '~hooks/useComplianceDocumentTypes/models';

export type CompliantType = ComplianceDocument_Read['compliant_type'];

export class ComplianceDocument {
  constructor(
    private _id: string,
    private _compliant_type: CompliantType,
    private _compliant_id: string,
    private _value: string | null,
    private _expires_at: Dayjs | null,
    private _notification_sent_at: Dayjs | null,
    private _compliance_document_type: ComplianceDocumentTypeBasic | null,
    private _created_at: Dayjs | null,
    private _updated_at: Dayjs | null,
    private _discarded_at: Dayjs | null = null,
  ) {}

  public static parse(proto: ComplianceDocument_Read | ComplianceDocument_Read_Nested) {
    const full = proto as Partial<ComplianceDocument_Read>;

    return new ComplianceDocument(
      proto.id,
      proto.compliant_type,
      proto.compliant_id,
      proto.value ?? null,
      proto.expires_at ? dayjs(proto.expires_at) : null,
      full.notification_sent_at ? dayjs(full.notification_sent_at) : null,
      full.compliance_document_type
        ? ComplianceDocumentTypeBasic.parse(full.compliance_document_type)
        : null,
      full.created_at ? dayjs(full.created_at) : null,
      full.updated_at ? dayjs(full.updated_at) : null,
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get id() {
    return this._id;
  }
  public get compliantType() {
    return this._compliant_type;
  }
  public get compliantId() {
    return this._compliant_id;
  }
  public get value() {
    return this._value;
  }
  public get expiresAt() {
    return this._expires_at ? dayjs.utc(this._expires_at) : null;
  }
  public get notificationSentAt() {
    return this._notification_sent_at ? dayjs.tz(this._notification_sent_at) : null;
  }
  public get complianceDocumentType() {
    return this._compliance_document_type;
  }
  public get createdAt() {
    return this._created_at ? dayjs.tz(this._created_at) : null;
  }
  public get updatedAt() {
    return this._updated_at ? dayjs.tz(this._updated_at) : null;
  }
  public get discardedAt() {
    return this._discarded_at;
  }
}
